"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationResultSchema = void 0;
var constants_1 = require("../../constants");
exports.validationResultSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        claimCompletenessResultCode: {
            type: 'integer',
            enum: Object.values(constants_1.ClaimCompletenessResultCode),
            errorMessage: 'Should equate to a valid ClaimCompletenessResultCode Enum value',
        },
        cmhcLoanAccountNumberMatchFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        entityResolutionCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.EntityResolutionCode), [null]),
            errorMessage: 'Should equate to a valid EntityResolutionCode Enum value or null',
        },
        existingMainClaimFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        existingMainClaimStatusCheckFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        formCompletenessResultFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        homeownerLoanValidationFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        latestInsurancePolicyFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        loanLevelValidationTypeCode: {
            type: 'integer',
            enum: Object.values(constants_1.LoanLevelValidationTypeCode),
            errorMessage: 'Should equate to a valid LoanLevelValidationTypeCode Enum value',
        },
        loanStatusValidationFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        premiumPaidValidationFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        processClaimInMicsFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be boolean or null',
        },
        processClaimInMicsResultFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
    },
};
